<template>
  <div class="vx-row mt-2" >
    {{params.data.productName}}
   
   <!-- <feather-icon class="ml-5 cursor-pointer" placeholder="sadsadsa" icon="PlusSquareIcon" @click="popupAddNewProductToReceipt=true" svgClasses="h-full w-full" /> -->
   
   
  </div>
</template>

<script>
export default {
  name: "CellRendererDetail",
  data() {
    return {
      popupAddNewProductToReceipt:false,

      
    };
  },
 
 
};
</script>
